import OIDCSignOutCallback from './OIDCSignOutCallback';

export default OIDCSignOutCallback;
